
import { computed, defineComponent, onBeforeUnmount, onMounted, ref } from "vue";
import {
  provideSidebarContext,
  readSidebarDefaultOpen,
  SIDEBAR_COOKIE_MAX_AGE,
  SIDEBAR_COOKIE_NAME,
  SIDEBAR_KEYBOARD_SHORTCUT,
  SIDEBAR_LOCAL_STORAGE_KEY,
  SIDEBAR_WIDTH,
  SIDEBAR_WIDTH_ICON,
  useMediaQuery,
} from "./utils";

export default defineComponent({
  name: "SidebarProvider",
  props: {
    defaultOpen: {
      type: Boolean,
      default: undefined,
    },
  },
  setup(props) {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const openMobile = ref(false);
    const open = ref(
      props.defaultOpen !== undefined ? props.defaultOpen : readSidebarDefaultOpen()
    );

    const state = computed(() => (open.value ? "expanded" : "collapsed"));

    function setOpen(value: boolean) {
      open.value = value;
      document.cookie = `${SIDEBAR_COOKIE_NAME}=${value}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`;
      window.localStorage.setItem(SIDEBAR_LOCAL_STORAGE_KEY, String(value));
    }

    function setOpenMobile(value: boolean) {
      openMobile.value = value;
    }

    function toggleSidebar() {
      if (isMobile.value) {
        setOpenMobile(!openMobile.value);
        return;
      }

      setOpen(!open.value);
    }

    function onKeydown(event: KeyboardEvent) {
      if (event.key === SIDEBAR_KEYBOARD_SHORTCUT && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        toggleSidebar();
      }
    }

    provideSidebarContext({
      state,
      open,
      setOpen,
      isMobile,
      openMobile,
      setOpenMobile,
      toggleSidebar,
    });

    onMounted(() => {
      window.addEventListener("keydown", onKeydown);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("keydown", onKeydown);
    });

    return {
      wrapperStyle: {
        "--sidebar-width": SIDEBAR_WIDTH,
        "--sidebar-width-icon": SIDEBAR_WIDTH_ICON,
      },
    };
  },
});
